import { COVERAGE_NAMES } from "@platform/rfp-core";

import Vision from "./Vision";
import LongTermDisability from "./LongTermDisability";
import FamilyMedicalLeaveAdministration from "./FamilyMedicalLeaveAdministration";
import BasicLife from "./BasicLifeAD&D";
import ShortTermDisability from "./ShortTermDisability";
import VoluntaryLifeADD from "./VoluntaryLifeADD";
import Accident from "./Accident";
import EmployeeAssistanceProgram from "./EmployeeAssistanceProgram";
import IndividualDisability from "./IndividualDisability";
import StateDisabilityLeaves from "./StateDisabilityLeaves";
import Dental from "./Dental";

const {
  ACCIDENT,
  VISION,
  CANCER,
  CI,
  HOSPITAL,
  WHOLE_LIFE,
  LTD,
  FMLA,
  BASIC_LIFE,
  VOLUNTARY_LIFE,
  STD,
  EAP,
  DENTAL,
  DENTAL_PPO,
  DENTAL_DHMO,
  INDIVIDUAL_DISABILITY,
  SDL,
} = COVERAGE_NAMES;

export default function index({ ...props }) {
  const coverage = props.coverage.name;

  switch (coverage) {
    case VISION:
      return <Vision key={coverage} {...props} />;
    case ACCIDENT:
    case CANCER:
    case CI:
    case HOSPITAL:
    case WHOLE_LIFE:
      return <Accident key={coverage} {...props} />;
    case LTD:
      return <LongTermDisability key={coverage} {...props} />;
    case FMLA:
      return <FamilyMedicalLeaveAdministration key={coverage} {...props} />;
    case BASIC_LIFE:
      return <BasicLife key={coverage} {...props} />;
    case VOLUNTARY_LIFE:
      return <VoluntaryLifeADD key={coverage} {...props} />;
    case STD:
      return <ShortTermDisability key={coverage} {...props} />;
    case EAP:
      return <EmployeeAssistanceProgram key={coverage} {...props} />;
    case DENTAL:
    case DENTAL_PPO:
    case DENTAL_DHMO:
      return <Dental key={coverage} {...props} />;
    case INDIVIDUAL_DISABILITY:
      return <IndividualDisability key={coverage} {...props} />;
    case SDL:
      return <StateDisabilityLeaves key={coverage} {...props} />;
    default:
      return <div>Form Not found</div>;
  }
}
